// extracted by mini-css-extract-plugin
export var cancelButton = "_lm-5";
export var content = "_lm-3";
export var createButton = "_lm-6";
export var drawerContainer = "_lm-0";
export var footer = "_lm-2";
export var header = "_lm-1";
export var orderFormColumn = "_lm-4";